import { For } from "solid-js";
import type { GovernRoleKey } from "../../enums/govern";
import { GOVERN_ROLE_KEY } from "../../enums/govern";
import { isAssigned } from "./governStatus";
import type { GovernWorkItem } from "./governTypes";

const ROLE_DETAILS: Array<{
  key: GovernRoleKey;
  label: string;
  detail: string;
}> = [
  {
    key: GOVERN_ROLE_KEY.DELIVERY_OWNER,
    label: "Delivery owner",
    detail: "Responsible for completing the work.",
  },
  {
    key: GOVERN_ROLE_KEY.REVIEWER,
    label: "Reviewer",
    detail: "Checks quality and implementation before verification.",
  },
  {
    key: GOVERN_ROLE_KEY.APPROVER,
    label: "Approver",
    detail: "Confirms required business, legal or strategic decisions.",
  },
  {
    key: GOVERN_ROLE_KEY.VERIFIER,
    label: "Verifier",
    detail: "Records whether the Brief acceptance criteria passed.",
  },
  {
    key: GOVERN_ROLE_KEY.REVIEW_OWNER,
    label: "Review owner",
    detail: "Owns the scheduled post-delivery review.",
  },
];

export function GovernRoles(props: {
  work: GovernWorkItem;
  onEdit: (trigger: HTMLElement) => void;
}) {
  return (
    <section class="govern-plan-section govern-roles-section">
      <header>
        <div>
          <span class="signal-mini-kicker">Decision rights</span>
          <h3>Ownership and review roles</h3>
        </div>
        <button
          type="button"
          class="govern-text-action"
          onClick={(event) => props.onEdit(event.currentTarget)}
        >
          Assign roles
        </button>
      </header>
      <div class="govern-role-grid">
        <For each={ROLE_DETAILS}>
          {(role) => (
            <article
              class={
                isAssigned(props.work.roles[role.key])
                  ? "is-assigned"
                  : "is-unassigned"
              }
            >
              <strong>{role.label}</strong>
              <span>
                {isAssigned(props.work.roles[role.key])
                  ? props.work.roles[role.key]
                  : "Not assigned"}
              </span>
              <p>{role.detail}</p>
            </article>
          )}
        </For>
      </div>
    </section>
  );
}
